import { $applyNodeReplacement, TextNode } from "lexical";

function $convertMentionElement(domNode) {
	const textContent = domNode.textContent;
	const id = domNode.getAttribute("data-lexical-mention-id");

	if (!textContent) return null;

	// textContent ALREADY contains @Name
	const cleanText = textContent.startsWith("@")
		? textContent.slice(1)
		: textContent;

	return {
		node: $createMentionNode(cleanText, id)
	};
}

export class MentionNode extends TextNode {
	static getType() {
		return "mention";
	}

	static clone(node) {
		return new MentionNode(node.__name, node.__id, node.__key);
	}

	static importJSON(serializedNode) {
		return $createMentionNode(serializedNode.name, serializedNode.id)
			.updateFromJSON(serializedNode);
	}

	constructor(name, id, key) {
		// Store internally without @
		super("@" + name, key);
		this.__name = name; 
		this.__id = id;      
	}

	exportJSON() {
		return {
			...super.exportJSON(),
			name: this.__name,
			id: this.__id,
			type: "mention",
			version: 1
		};
	}

	createDOM(config) {
		const dom = super.createDOM(config);
		dom.className = "mention";
		dom.spellcheck = false;
		return dom;
	}

	exportDOM() {
		const element = document.createElement("span");
		element.setAttribute("data-lexical-mention", "true");
		element.setAttribute("data-lexical-mention-id", this.__id || "");
		element.classList.add("mention");
		element.textContent = "@" + this.__name;
		return { element };
	}

	static importDOM() {
		return {
			span: (domNode) => {
				if (!domNode.hasAttribute("data-lexical-mention")) return null;
				return { conversion: $convertMentionElement, priority: 1 };
			}
		};
	}

	isTextEntity() {
		return true;
	}

	canInsertTextBefore() {
		return false;
	}

	canInsertTextAfter() {
		return false;
	}
}

export function $createMentionNode(name, id) {
	const node = new MentionNode(name, id);
	node.setMode("segmented").toggleDirectionless();
	return $applyNodeReplacement(node);
}

export function $isMentionNode(node) {
	return node instanceof MentionNode;
}
